var map = {
	"./": [
		312,
		9
	],
	"./Content": [
		1117,
		9,
		0,
		1,
		7,
		88
	],
	"./Content.dictionary": [
		1119,
		3,
		89
	],
	"./Content.dictionary.json": [
		1119,
		3,
		89
	],
	"./Content.jsx": [
		1117,
		9,
		0,
		1,
		7,
		88
	],
	"./ContentDeferred": [
		351,
		9
	],
	"./ContentDeferred.jsx": [
		351,
		9
	],
	"./InterestingMatches": [
		1004,
		9,
		17
	],
	"./InterestingMatches/": [
		1004,
		9,
		17
	],
	"./InterestingMatches/InterestingMatches.dictionary": [
		1020,
		3,
		103
	],
	"./InterestingMatches/InterestingMatches.dictionary.json": [
		1020,
		3,
		103
	],
	"./InterestingMatches/InterestingMatches.module.scss": [
		837,
		9,
		255
	],
	"./InterestingMatches/actions": [
		98,
		9
	],
	"./InterestingMatches/actions.ts": [
		98,
		9
	],
	"./InterestingMatches/components/Contetnt": [
		923,
		9,
		18
	],
	"./InterestingMatches/components/Contetnt/": [
		923,
		9,
		18
	],
	"./InterestingMatches/components/Contetnt/Content.dictionary": [
		959,
		3,
		104
	],
	"./InterestingMatches/components/Contetnt/Content.dictionary.json": [
		959,
		3,
		104
	],
	"./InterestingMatches/components/Contetnt/Content.module.scss": [
		1019,
		9,
		256
	],
	"./InterestingMatches/components/Contetnt/index": [
		923,
		9,
		18
	],
	"./InterestingMatches/components/Contetnt/index.tsx": [
		923,
		9,
		18
	],
	"./InterestingMatches/components/Match": [
		843,
		9,
		19
	],
	"./InterestingMatches/components/Match/": [
		843,
		9,
		19
	],
	"./InterestingMatches/components/Match/Match.dictionary": [
		848,
		3,
		105
	],
	"./InterestingMatches/components/Match/Match.dictionary.json": [
		848,
		3,
		105
	],
	"./InterestingMatches/components/Match/index": [
		843,
		9,
		19
	],
	"./InterestingMatches/components/Match/index.tsx": [
		843,
		9,
		19
	],
	"./InterestingMatches/components/Sport": [
		958,
		9,
		106
	],
	"./InterestingMatches/components/Sport.tsx": [
		958,
		9,
		106
	],
	"./InterestingMatches/components/Stage": [
		874,
		9,
		107
	],
	"./InterestingMatches/components/Stage.tsx": [
		874,
		9,
		107
	],
	"./InterestingMatches/components/Tournament": [
		892,
		9,
		108
	],
	"./InterestingMatches/components/Tournament.jsx": [
		892,
		9,
		108
	],
	"./InterestingMatches/components/Union": [
		924,
		9,
		109
	],
	"./InterestingMatches/components/Union.jsx": [
		924,
		9,
		109
	],
	"./InterestingMatches/constants": [
		925,
		9,
		110
	],
	"./InterestingMatches/constants.ts": [
		925,
		9,
		110
	],
	"./InterestingMatches/index": [
		1004,
		9,
		17
	],
	"./InterestingMatches/index.jsx": [
		1004,
		9,
		17
	],
	"./InterestingMatches/reducer": [
		295,
		9
	],
	"./InterestingMatches/reducer/": [
		295,
		9
	],
	"./InterestingMatches/reducer/entities": [
		368,
		9
	],
	"./InterestingMatches/reducer/entities.js": [
		368,
		9
	],
	"./InterestingMatches/reducer/grid": [
		369,
		9
	],
	"./InterestingMatches/reducer/grid.js": [
		369,
		9
	],
	"./InterestingMatches/reducer/index": [
		295,
		9
	],
	"./InterestingMatches/reducer/index.js": [
		295,
		9
	],
	"./InterestingMatches/selectors": [
		829,
		9,
		20
	],
	"./InterestingMatches/selectors/": [
		829,
		9,
		20
	],
	"./InterestingMatches/selectors/entities": [
		274,
		9
	],
	"./InterestingMatches/selectors/entities.ts": [
		274,
		9
	],
	"./InterestingMatches/selectors/grid": [
		847,
		9,
		111
	],
	"./InterestingMatches/selectors/grid.ts": [
		847,
		9,
		111
	],
	"./InterestingMatches/selectors/index": [
		829,
		9,
		20
	],
	"./InterestingMatches/selectors/index.ts": [
		829,
		9,
		20
	],
	"./LandingPage.module.scss": [
		1158,
		9,
		257
	],
	"./MatchOfTheDay": [
		1005,
		9,
		1,
		7,
		27
	],
	"./MatchOfTheDay/": [
		1005,
		9,
		1,
		7,
		27
	],
	"./MatchOfTheDay/actions": [
		305,
		9
	],
	"./MatchOfTheDay/actions.ts": [
		305,
		9
	],
	"./MatchOfTheDay/components/Carousel": [
		960,
		9,
		1,
		7,
		28
	],
	"./MatchOfTheDay/components/Carousel/": [
		960,
		9,
		1,
		7,
		28
	],
	"./MatchOfTheDay/components/Carousel/Carousel.module.scss": [
		1118,
		9,
		263
	],
	"./MatchOfTheDay/components/Carousel/index": [
		960,
		9,
		1,
		7,
		28
	],
	"./MatchOfTheDay/components/Carousel/index.tsx": [
		960,
		9,
		1,
		7,
		28
	],
	"./MatchOfTheDay/components/MainStakes": [
		926,
		9,
		29
	],
	"./MatchOfTheDay/components/MainStakes/": [
		926,
		9,
		29
	],
	"./MatchOfTheDay/components/MainStakes/MainStakes.module.scss": [
		1021,
		9,
		264
	],
	"./MatchOfTheDay/components/MainStakes/index": [
		926,
		9,
		29
	],
	"./MatchOfTheDay/components/MainStakes/index.tsx": [
		926,
		9,
		29
	],
	"./MatchOfTheDay/components/MatchTile": [
		961,
		9,
		30
	],
	"./MatchOfTheDay/components/MatchTile/": [
		961,
		9,
		30
	],
	"./MatchOfTheDay/components/MatchTile/MatchDetails": [
		1022,
		9,
		131
	],
	"./MatchOfTheDay/components/MatchTile/MatchDetails.tsx": [
		1022,
		9,
		131
	],
	"./MatchOfTheDay/components/MatchTile/MatchTile.module.scss": [
		962,
		9,
		265
	],
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary": [
		1023,
		3,
		132
	],
	"./MatchOfTheDay/components/MatchTile/MatchTitle.dictionary.json": [
		1023,
		3,
		132
	],
	"./MatchOfTheDay/components/MatchTile/index": [
		961,
		9,
		30
	],
	"./MatchOfTheDay/components/MatchTile/index.tsx": [
		961,
		9,
		30
	],
	"./MatchOfTheDay/images/background.svg": [
		1171,
		1,
		266
	],
	"./MatchOfTheDay/images/pattern.svg": [
		1172,
		1,
		267
	],
	"./MatchOfTheDay/index": [
		1005,
		9,
		1,
		7,
		27
	],
	"./MatchOfTheDay/index.tsx": [
		1005,
		9,
		1,
		7,
		27
	],
	"./MatchOfTheDay/reducer": [
		370,
		9
	],
	"./MatchOfTheDay/reducer.ts": [
		370,
		9
	],
	"./MatchOfTheDay/selectors": [
		883,
		9,
		31
	],
	"./MatchOfTheDay/selectors/": [
		883,
		9,
		31
	],
	"./MatchOfTheDay/selectors/entities": [
		279,
		9
	],
	"./MatchOfTheDay/selectors/entities.ts": [
		279,
		9
	],
	"./MatchOfTheDay/selectors/grid": [
		914,
		9,
		133
	],
	"./MatchOfTheDay/selectors/grid.ts": [
		914,
		9,
		133
	],
	"./MatchOfTheDay/selectors/index": [
		883,
		9,
		31
	],
	"./MatchOfTheDay/selectors/index.ts": [
		883,
		9,
		31
	],
	"./MatchOfTheDay/utils/get-match-ids-from-banners": [
		1060,
		9,
		134
	],
	"./MatchOfTheDay/utils/get-match-ids-from-banners.ts": [
		1060,
		9,
		134
	],
	"./MiniBanners": [
		1006,
		9,
		0,
		32
	],
	"./MiniBanners/": [
		1006,
		9,
		0,
		32
	],
	"./MiniBanners/MiniBanners": [
		963,
		9,
		0,
		135
	],
	"./MiniBanners/MiniBanners.module.scss": [
		1024,
		9,
		268
	],
	"./MiniBanners/MiniBanners.tsx": [
		963,
		9,
		0,
		135
	],
	"./MiniBanners/components/Content": [
		893,
		9,
		0,
		33
	],
	"./MiniBanners/components/Content/": [
		893,
		9,
		0,
		33
	],
	"./MiniBanners/components/Content/Content": [
		875,
		9,
		0,
		136
	],
	"./MiniBanners/components/Content/Content.module.scss": [
		927,
		9,
		269
	],
	"./MiniBanners/components/Content/Content.tsx": [
		875,
		9,
		0,
		136
	],
	"./MiniBanners/components/Content/index": [
		893,
		9,
		0,
		33
	],
	"./MiniBanners/components/Content/index.ts": [
		893,
		9,
		0,
		33
	],
	"./MiniBanners/index": [
		1006,
		9,
		0,
		32
	],
	"./MiniBanners/index.ts": [
		1006,
		9,
		0,
		32
	],
	"./images/telegram.svg": [
		1173,
		1,
		310
	],
	"./index": [
		312,
		9
	],
	"./index.tsx": [
		312,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1239;
module.exports = webpackAsyncContext;